export default [
  {
    path: '/noLoginSign',
    name: 'NoLoginSign',
    component: () => import('@/views/feishu/noLoginSign.vue'),
    meta: { title: 'scan_signin', hidden: true }
  },
  {
    path: '/qiweiTransit',
    name: 'QiweiTransit',
    component: () => import('@/views/feishu/qiweiTransit.vue'),
    meta: { title: 'app_sandstalk', hidden: true }
  }
]
